import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Constants`}</p>
    <dl>
      <dt><a href="#useWindowSize">useWindowSize</a> : <inlineCode>number</inlineCode></dt>
      <dd>
        <p>{`The current context value for the window size context.
This value updates whenever the window is resized.`}</p>
        <p>{`Use this inside a `}<a parentName="p" {...{
            "href": "#WindowSizeContextProvider"
          }}>{`WindowSizeContextProvider`}</a>{`.`}</p>
      </dd>
    </dl>
    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#WindowSizeContextProvider">WindowSizeContextProvider(props)</a> ⇒ <inlineCode>Context.Provider</inlineCode></dt>
      <dd>
        <p>{`This component contains a hook that listens for resize events.
Use this component with `}<a parentName="p" {...{
            "href": "#useWindowSize"
          }}>{`useWindowSize`}</a>{` to get the value of the resized window.`}</p>
        <p>{`It is recommended to only create/use a single time at the top level of your app`}</p>
      </dd>
    </dl>
    <p>{`The current context value for the window size context.
This value updates whenever the window is resized.`}</p>
    <p>{`Use this inside a `}<a parentName="p" {...{
        "href": "#WindowSizeContextProvider"
      }}>{`WindowSizeContextProvider`}</a>{`.`}</p>
    <p>{`This component contains a hook that listens for resize events.
Use this component with `}<a parentName="p" {...{
        "href": "#useWindowSize"
      }}>{`useWindowSize`}</a>{` to get the value of the resized window.`}</p>
    <p>{`It is recommended to only create/use a single time at the top level of your app`}</p>
    <p><strong parentName="p">{`Summary`}</strong>{`: A React context provider.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`Context.Provider`}</inlineCode>{`
— A `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/context.html"
      }}>{`React context provider`}</a></p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`React component props`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/hooks/useWindowSize.js"
      }}>{`pwa-studio/packages/peregrine/lib/hooks/useWindowSize.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      